import { render, staticRenderFns } from "./VideoCallReminder.vue?vue&type=template&id=2ed96116&"
import script from "./VideoCallReminder.vue?vue&type=script&lang=js&"
export * from "./VideoCallReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports